<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card>
          <md-card-header data-background-color="red">
            <h4 class="title">My Donation</h4>
            <button class="buttonEdit addBtn" @click="addDonateInfo">
            <span style="font-weight: bolder; font-size: 20px">
             +
            </span>
            </button>
            <p class="category">List of all my donations</p>

          </md-card-header>
          <md-card-content>
            <div table-header-color="green" :addList="addNewItem">

              <md-table v-model="donorsList" :table-header-color="tableHeaderColor">
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="Date">{{ item.donation_date }}</md-table-cell>
                  <md-table-cell md-label="Location">{{ item.local_area }}</md-table-cell>
                  <md-table-cell md-label="Notes">{{ item.notes }}</md-table-cell>
                  <md-table-cell md-label="Action">
                    <button class="buttonEdit" @click="editDonateInfo(item)">
            <span>
              <i class="fa fa-edit"></i>
            </span>
                    </button>
                    <button class="buttonDelete" @click="deleteitem = true">
            <span>
              <i class="fa fa-trash"></i>
            </span>
                    </button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
              <md-dialog :md-active.sync="deleteitem"  style="width: 50%">
                <md-dialog-title>Delete Donor</md-dialog-title>
                <div style="width: 70%; margin: 10px auto">
                  <i class="fa fa-trash" style="margin-left: -5%; font-size: 34px"></i>
                  <span style="margin-left: 5%;font-size: 20px">Are you sure?</span>
                </div>
                <md-dialog-actions>
                  <md-button class="md-primary" @click="deleteitem = false">Close</md-button>
                  <md-button class="md-primary" @click="deleteDonationInfo(item)">Delete</md-button>
                </md-dialog-actions>

              </md-dialog>

            </div>
          </md-card-content>
        </md-card>
      </div>

    </div>
    <md-dialog :md-active.sync="add" style="width: 50%">
      <md-dialog-title>Add New</md-dialog-title>
      <div class="md-layout" style="width: 70%; margin: 10px auto; height:100%;">
        <md-datepicker v-model="date"  >
          <label>Date</label>
        </md-datepicker>
        <md-field>
          <label>Location</label>
          <md-input v-model="location"></md-input>
        </md-field>

        <md-field :md-counter="false">
          <label>Notes</label>
          <md-input v-model="notes"></md-input>
        </md-field>

      </div>
      <md-dialog-actions>
        <md-button class="md-primary" @click="add = false">Close</md-button>
        <md-button class="md-primary" @click="addNew">Add</md-button>
      </md-dialog-actions>
    </md-dialog>

  </div>
</template>

<script>
  var moment = require('moment');
  export default{
    name: 'simple-table',
    props: {
      tableHeaderColor: {
        type: String,
        default: '',
      },

    },
    data(){
      return{
        addNewItem: {},
        add: false,
        date:'',
        location:'',
        notes:'',
        selected: [],
        donorsList: [],
        edit: false,
        deleteitem: false,
      }
    },
    beforeMount: function () {
      this.$store.dispatch('GetMyDonationList').then((response)=> {
        this.donorsList = response.data.data;
        console.log('donorlist',this.donorsList)
      });
      this.$store.commit('setDonation',{})
    },
    watch:{
      addList(){
        this.donorsList.push(this.addList)
      }
    },

    methods:{
      addNew: function(){
        this.date= moment(this.date).format('YYYY-MM-DD');
        let addNewDonationData ={
          donation_date: this.date,
          local_area: this.location,
          notes: this.notes
        }
        console.log(addNewDonationData)
      },
      editDonateInfo(donation){
        this.$store.commit('setDonation',donation)
        this.$emit('switchPanel','MyDonationForm')
      },
      addDonateInfo(donation){
        this.$store.commit('clearInfoDonation',donation)
        this.$emit('switchPanel','MyDonationForm')
      },
      deleteDonationInfo(donation){
        this.deleteitem= false
      }
    }

  }
</script>
<style>
  .buttonEdit {
    border-radius: 4px;
    background-color: #0080ff;
    padding: 5px;
    border: none;
    color: #FFFFFF;
    text-align: center;
    font-size: 16px;
    transition: all 0.5s;
    cursor: pointer;
    margin: 5px;
    margin-right: 10px;

  }

  .buttonDelete {
    border-radius: 4px;
    background-color: #f4511e;
    padding: 5px;
    border: none;
    color: #FFFFFF;
    text-align: center;
    font-size: 16px;
    transition: all 0.5s;
    cursor: pointer;
    margin: 5px;
  }
  .addBtn{
    margin-top: 10px;
    float: right;
    background-color: #00c853;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    box-shadow: 0 12px 20px -10px rgba(244, 67, 54, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(244, 67, 54, 0.2)
  }


</style>
